import { Box } from '@bridebook/ui';
import styles from './app-bar-mobile-default.style';

export const APP_BAR_MOBILE_DEFAULT_OFFSET = 0;

interface AppBarMobileDefaultProps {
  safeAreaBackgroundColor?: string;
}

// App bar is fully hidden on mobile — mobile home provides its own header.
const AppBarMobileDefault = ({ safeAreaBackgroundColor }: AppBarMobileDefaultProps = {}) => (
  <Box style={styles.empty(safeAreaBackgroundColor)} />
);

export default AppBarMobileDefault;
